"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeItem = undefined;

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var removeItem = exports.removeItem = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(key) {
    var state, attribute_id, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, item;

    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            state = void 0;
            // If main product, assign attribute_id

            _context.next = 3;
            return cart.getItem(key).then(function (item) {
              if (item.properties._main) {
                return item.properties._attributes_id;
              }
            });

          case 3:
            attribute_id = _context.sent;
            _context.next = 6;
            return cart.removeItem(key).then(function (state) {
              return state;
            });

          case 6:
            state = _context.sent;

            if (!(attribute_id != undefined)) {
              _context.next = 36;
              break;
            }

            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _iteratorError = undefined;
            _context.prev = 11;
            _iterator = state.items[Symbol.iterator]();

          case 13:
            if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
              _context.next = 22;
              break;
            }

            item = _step.value;

            if (!(item.properties._attributes_id == attribute_id)) {
              _context.next = 19;
              break;
            }

            _context.next = 18;
            return cart.removeItem(item.key).then(function (state) {
              return state;
            });

          case 18:
            state = _context.sent;

          case 19:
            _iteratorNormalCompletion = true;
            _context.next = 13;
            break;

          case 22:
            _context.next = 28;
            break;

          case 24:
            _context.prev = 24;
            _context.t0 = _context["catch"](11);
            _didIteratorError = true;
            _iteratorError = _context.t0;

          case 28:
            _context.prev = 28;
            _context.prev = 29;

            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }

          case 31:
            _context.prev = 31;

            if (!_didIteratorError) {
              _context.next = 34;
              break;
            }

            throw _iteratorError;

          case 34:
            return _context.finish(31);

          case 35:
            return _context.finish(28);

          case 36:
            return _context.abrupt("return", state);

          case 37:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this, [[11, 24, 28, 36], [29,, 31, 35]]);
  }));

  return function removeItem(_x) {
    return _ref.apply(this, arguments);
  };
}();

exports.renderMiniCart = renderMiniCart;
exports.init = init;

var _themeCurrency = require("@shopify/theme-currency");

var _themeImages = require("@shopify/theme-images");

var images = _interopRequireWildcard(_themeImages);

var _cart = require("../modules/cart.js");

var _themeCart = require("@shopify/theme-cart");

var cart = _interopRequireWildcard(_themeCart);

var _micromodal = require("micromodal");

var _micromodal2 = _interopRequireDefault(_micromodal);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var selectors = {
  cart: "#mini-cart",
  modal: "modal-mini-cart",
  remove: "[data-mini-remove-item]",
  item: "[data-mini-item]",
  checkout: "[data-mini-checkout]",
  viewCart: "[data-mini-view-cart]",
  subtotal: "[data-mini-subtotal]",
  count: "[data-mini-count]",
  emptyText: "Your cart is currently empty."
}; // Mini cart


function removeItemListener() {
  document.querySelectorAll(selectors.remove).forEach(function (trigger) {
    trigger.addEventListener("click", function () {
      var key = this.getAttribute("data-key");

      removeItem(key).then(function (state) {
        renderMiniCart(state);
        // If on cart page, remove the item from cart list too
        if (window.location.href.indexOf("/cart") > -1) {
          (0, _cart.renderCart)(state);
        }
      });
    });
  });
}

function renderItems(state) {
  var selector = document.querySelector(selectors.cart);
  selector.innerHTML = "";
  var container = document.createElement("div");
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = state.items[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var item = _step2.value;

      var img = "";
      if (item.image) {
        img = "<a href='" + item.url + "'><img src='" + images.getSizedImageUrl(item.image, "150x150") + "' /></a>";
      }
      var properties = "";
      for (var property in item.properties) {
        if (property.charAt(0) != "_") {
          var line = "<p>" + property + ": " + item.properties[property] + "</p>";
          properties = properties + line;
        }
      }
      if (properties != "") {
        properties = "<div class=\"text-battleshipGrey text-12\">" + properties + "</div>";
      }
      var price = "";
      if (item.discounted_price != item.price) {
        price = "<s class=\"mr-2 text-battleshipGrey\">" + (0, _themeCurrency.formatMoney)(item.price) + "</s>\n    <span>" + (0, _themeCurrency.formatMoney)(item.discounted_price) + "</span>";
      } else {
        price = "<span>" + (0, _themeCurrency.formatMoney)(item.price) + "</span>";
      }
      var variant_title = "";
      if (item.variant_title != null) {
        variant_title = "<div class=\"text-battleshipGrey text-12\"><p>" + item.variant_title + "</p></div>";
      }
      var template = "\n          <div data-mini-item>\n              <div class=\"flex items-center\">\n                  <div class=\"max-w-6xs w-full\">" + img + "</div>\n                  <div class=\"ml-8\">\n                      <h3 class=\"text-14 leading-.2 pt-1 pb-0\"><a href=\"" + item.url + "\">" + item.product_title + "</a></h3>\n                      " + variant_title + "\n                      " + properties + "\n                      <p class=\"text-12 uppercase text-battleshipGrey pt-1 pb-0\">\n                        Qt: <span>" + item.quantity + "</span>\n                      </p>\n                      <div class=\"text-15 pt-1 pb-0\">\n                        " + price + "\n                      </div>\n                      <p class=\"text-12 text-battleshipGrey underline pt-1 pb-0\">\n                          <a class=\"cursor-pointer\" data-mini-remove-item data-key=\"" + item.key + "\">Remove</a>\n                      </p>\n                  </div>\n             </div>\n             <div class=\"py-8\">\n                <hr class=\"divider\" />\n              </div>\n           </div>\n          ";
      container.innerHTML += template;
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  selector.appendChild(container);
}

// Update count in mini cart and also in header for mobile
function renderCount(state) {
  document.querySelectorAll(selectors.count).forEach(function (item) {
    item.innerHTML = "(" + state.item_count + ")";
    if (state.items.length <= 0) {
      var selector = document.querySelector(selectors.cart);
      selector.innerHTML = "<p>" + selectors.emptyText + "</p>";
      document.querySelector(selectors.checkout).classList.add("hidden");
      document.querySelector(selectors.viewCart).classList.add("btn");
    } else {
      document.querySelector(selectors.checkout).classList.remove("hidden");
      document.querySelector(selectors.viewCart).classList.remove("btn");
    }
  });
}

function renderSubtotal(state) {
  document.querySelector(selectors.subtotal).innerHTML = (0, _themeCurrency.formatMoney)(state.items_subtotal_price);
}

// Render mini cart with option to hide modal. Also optional state for adding to cart on mobile
function renderMiniCart(state, hide, mobile) {
  renderItems(state);
  renderSubtotal(state);
  renderCount(state);
  removeItemListener();
  if (hide != true) {
    document.querySelector("[data-mini-cart-open]").click();
    if (mobile == true) {
      document.querySelector("[data-mini-desktop]").classList.add("hidden");
      document.querySelector("[data-mini-desktop]").classList.add("md:block");
      document.querySelector("[data-mini-added]").classList.remove("hidden");
    }
  }
}

function init() {
  cart.getState().then(function (state) {
    renderMiniCart(state, true);
  });
}